import { render, staticRenderFns } from "./editParkingSpace.vue?vue&type=template&id=59151f0a"
import script from "./editParkingSpace.vue?vue&type=script&lang=js"
export * from "./editParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports